import { render, staticRenderFns } from "./ProjectDeviceParamSettings.vue?vue&type=template&id=0950c7fe&scoped=true&"
import script from "./ProjectDeviceParamSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectDeviceParamSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0950c7fe",
  null
  
)

export default component.exports